import React from 'react';
import ReactDOM from 'react-dom';

import Router from './Router';
import { initBranchFetchInterceptor } from './utils/branch';

initBranchFetchInterceptor();

ReactDOM.render(
  <React.StrictMode>
    <Router />
  </React.StrictMode>,
  document.getElementById('root')
);
